import { createSelector } from 'reselect';
import { RootState, DeveloperMenuState } from '../model/state';

/**
 * Direct selector to the state
 */
const selectDeveloperMenu = () => (state: RootState) => state.developerMenu;

/**
 * Other specific selectors
 */
const selectIsSubmittingDeveloperMenu = () => createSelector(
  selectDeveloperMenu(),
  (developerMenu: DeveloperMenuState) => developerMenu.developerMenuSettings.isSubmitting
);

const selectDeveloperMenuSettings = () => createSelector(
  selectDeveloperMenu(),
  (developerMenu: DeveloperMenuState) => developerMenu.developerMenuSettings.settings
);

export default selectDeveloperMenu;
export {
  selectIsSubmittingDeveloperMenu,
  selectDeveloperMenuSettings,
}
